import { api } from 'src/tools/api';

export const getAllProposals = (page, perPage, where = {}) => api.get('/proposal', {
  params: {
    page, perPage, where,
  },
});

export const getProposal = async (uuid) => api.get(`/proposal/${uuid}`);

export const getProposalsStatistics = () => api.get('/proposal/statistics');

export const findOrCreate = (params) => api.post('/proposal', params);

export const update = (id, params) => api.patch(`/proposal/${id}`, params);

export const createPayment = async (id, params) => api.post(`/payment/${id}`, params);

export const toggleEmail = async (uuid) => api.get(`/proposal/mail/${uuid}`);

